/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  MicrosoftSignupNonce
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Issue a single-use nonce for one Microsoft sign-in popup.
 * @summary Microsoft Signup Nonce
 */
export const microsoftSignupNonce = (

 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<MicrosoftSignupNonce>(
      {url: `/auth/microsoft-signup/nonce`, method: 'POST', signal
    },
      options);
    }




export const getMicrosoftSignupNonceMutationKey = () => ['microsoftSignupNonce'] as const;

export const getMicrosoftSignupNonceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof microsoftSignupNonce>>, TError,void, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof microsoftSignupNonce>>, TError,void, TContext> => {

const mutationKey = getMicrosoftSignupNonceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof microsoftSignupNonce>>, void> = () => {


          return  microsoftSignupNonce(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MicrosoftSignupNonceMutationResult = NonNullable<Awaited<ReturnType<typeof microsoftSignupNonce>>>

    export type MicrosoftSignupNonceMutationError = unknown


    /**
 * @summary Microsoft Signup Nonce
 */
export const useMicrosoftSignupNonce = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof microsoftSignupNonce>>, TError,void, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof microsoftSignupNonce>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMicrosoftSignupNonceMutationOptions(options));
    }
